import UsersPage from "@pages/users";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/users/")({
	component: UsersPage,
	staticData: {
		breadcrumbId: "page.users.title",
		breadcrumbTitle: "Users",
	},
});

